import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const GithubRepositoryIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GithubRepository",
    children: /*#__PURE__*/_jsx("path", {
      d: "M5.28 5.28c0-.87.35-1.7.96-2.32C6.85 2.35 7.69 2 8.56 2h17.26c.23 0 .46.09.63.26s.26.39.26.63V27.3c0 .24-.09.46-.26.63s-.39.26-.63.26h-7.15c-.24 0-.46-.09-.63-.26s-.26-.39-.26-.63.09-.46.26-.63.39-.26.63-.26h6.25v-4.76H8.85c-.47 0-.93.19-1.26.52-.34.34-.52.79-.52 1.26v.89c0 .85.51 1.59 1.25 1.91.21.1.37.28.45.49.08.22.07.46-.02.67s-.27.38-.48.47-.46.09-.67 0c-.69-.3-1.28-.8-1.69-1.43s-.63-1.37-.63-2.12zm19.64-1.49v16.07H8.85c-.65 0-1.26.17-1.79.48V5.28c0-.82.67-1.49 1.49-1.49zM10.04 23.73q0-.12.09-.21c.09-.09.13-.09.21-.09h5.96q.12 0 .21.09c.09.09.09.13.09.21v5.97s-.02.11-.04.16c-.03.05-.07.08-.12.11-.05.02-.1.04-.16.03a.22.22 0 0 1-.15-.06l-2.63-1.91s-.11-.06-.18-.06-.12.02-.18.06l-2.63 1.91s-.1.05-.15.06c-.05 0-.11 0-.16-.03a.25.25 0 0 1-.12-.11.3.3 0 0 1-.04-.15v-5.97Z"
    })
  }));
};